import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../store/actions';
import { IIndexable } from '../components/GraphicsLibrary/GraphicDetail/GraphicDetail';
import SnackBarType from '../objects/app/snackbar';
import {
    saveDesign,
    saveDesignImages,
    saveDesignReset,
    saveDesignImagesReset,
} from '../store/actions';
import { useTypedSelector } from '../shared/hooks/useTypedSelector';
import SaveDesignDialog from '../components/SaveDesignDialog/SaveDesignDialog';
import Loading from '../components/Loading/Loading';
import * as ValidateModel from '../shared/ValidateModel';
import Design from '../objects/graphicsLibrary/design';
import { Selected } from '../schemas/onlineDesigner';
import { IMember } from '../components/TeamDialog/TeamDialog';
import { useTranslation } from 'react-i18next';
interface Props {}

declare global {
    interface Window {
        startSaveDesign: any;
        startSaveDesignImages: any;
        saveDesignAfterImagesLoad: any;
        startSaveDesignImagesAfterImagesLoad: any;
        GET_DESIGN_FCE_NAME: string;
        GET_DESIGN_NAME_FCE_NAME: string;
        GET_IMAGES_FCE_NAME: string;
    }
}

export interface ISelectedSize {
    id: string | number;
    name: string;
    count: string | number;
}

export interface IOnSuccessFce {
    (design: Design, params: any | null): void;
}

interface Props {
    customerId: number | null;
    guestId: number | null;
}

const SaveContainer: React.FC<Props> = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { customerId, guestId } = props;

    const [idProduct, setIdProduct] = useState(0);
    const [idDesign, setIdDesign] = useState(0);
    const [onSuccessFceName, setOnSuccessFceName] = React.useState<
        null | string
    >(null);
    const [onSuccessParams, setOnSuccessParams] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [onlyDesign, setOnlyDesign] = useState(false);
    const [requireName, setRequireName] = useState(false);
    const [addToCart, setAddToCart] = useState(false);
    const [addProofService, setAddProofService] = useState(false);
    const [saveAsNew, setSaveAsNew] = useState(false);

    const messages = {
        saveDesignSuccess: t('Design saved successfully.'),
        saveDesignImagesSuccess: t('Design images saved successfully.'),
        addToCartSuccess: t('Design added to cart.'),
    };

    const {
        success: saveDesignSuccess,
        failed: saveDesignFailed,
        data: saveDesignData,
    } = useTypedSelector((state) => state.saveDesign.saveDesign);

    const {
        success: saveImagesSuccess,
        failed: saveImagesFailed,
        data: saveImagesData,
    } = useTypedSelector((state) => state.saveDesign.saveImages);

    const { data: selectedData } = useTypedSelector(
        (state) => state.od.selected
    );
    const { data: teamData } = useTypedSelector((state) => state.od.team);

    useEffect(() => {
        if (saveDesignFailed || saveImagesFailed) {
            resetParameters();
            if (saveDesignFailed) {
                dispatch(saveDesignReset());
            } else if (saveImagesFailed) {
                dispatch(saveDesignImagesReset());
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveDesignFailed, saveImagesFailed]);

    useEffect(() => {
        if (saveDesignSuccess) {
            if (
                saveDesignData &&
                saveDesignData.getId() !== null &&
                onSuccessFceName
            ) {
                (window as IIndexable)[onSuccessFceName](
                    saveDesignData,
                    onSuccessParams
                );
            }
            resetParameters();
            dispatch(saveDesignReset());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveDesignSuccess]);

    useEffect(() => {
        if (saveImagesSuccess) {
            if (
                saveImagesData &&
                saveImagesData.getId() !== null &&
                onSuccessFceName
            ) {
                if (
                    onSuccessFceName.length > 0 &&
                    window.hasOwnProperty(onSuccessFceName)
                ) {
                    (window as IIndexable)[onSuccessFceName](saveImagesData);
                }
                resetParameters();
                dispatch(saveDesignImagesReset());
            } else {
                dispatch(
                    actions.addSnackbar(
                        t('Design images save failed.'),
                        SnackBarType.ERROR,
                        false
                    )
                );
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveImagesSuccess]);

    useEffect(() => {
        try {
            ValidateModel.isWindowFce(
                'GET_DESIGN_FCE_NAME',
                window.GET_DESIGN_FCE_NAME
            );
            ValidateModel.isWindowFce(
                'GET_IMAGES_FCE_NAME',
                window.GET_IMAGES_FCE_NAME
            );
            ValidateModel.isWindowFce(
                'GET_DESIGN_NAME_FCE_NAME',
                window.GET_DESIGN_NAME_FCE_NAME
            );
        } catch (error: any) {
            dispatch(
                actions.addSnackbar(
                    t('Design save is not properly defined. ') + error.message,
                    SnackBarType.WARNING,
                    false
                )
            );
        }

        window.startSaveDesign = (
            idDesign: number,
            idProduct: number,
            requireName: boolean,
            onSuccessFceName: string,
            selectedData: Selected | null = null,
            teamData: IMember[] | null = null,
            onlyDesign: boolean = false,
            onSuccessParams: any = null,
            addToCart: boolean = false,
            addProofService: boolean = false,
            saveAsNew: boolean = false
        ) => {
            setIdProduct(idProduct);
            setIdDesign(idDesign);
            setOnSuccessFceName(onSuccessFceName);
            setOnSuccessParams(onSuccessParams);
            setIsOpen(true);
            setRequireName(requireName);
            setAddToCart(addToCart);
            setAddProofService(addProofService);
            setSaveAsNew(saveAsNew);
            setOnlyDesign(onlyDesign);

            if (!requireName) {
                if (onlyDesign) {
                    dispatch(
                        saveDesign(
                            idProduct,
                            idDesign,
                            customerId,
                            guestId,
                            window.GET_DESIGN_FCE_NAME,
                            null,
                            null,
                            selectedData,
                            teamData,
                            addToCart,
                            addProofService,
                            saveAsNew,
                            messages
                        )
                    );
                } else {
                    (window as IIndexable)[window.GET_IMAGES_FCE_NAME](
                        window.saveDesignAfterImagesLoad,
                        {
                            idProduct,
                            idDesign,
                            name: (window as IIndexable)[
                                window.GET_DESIGN_NAME_FCE_NAME
                            ](),
                            addToCart,
                            addProofService,
                            saveAsNew,
                            selectedData,
                            teamData,
                            messages,
                        }
                    );
                }
            }
        };

        window.startSaveDesignImages = (
            idDesign: number,
            idProduct: number,
            onSuccessFceName: string
        ) => {
            setIdDesign(idDesign);
            setOnSuccessFceName(onSuccessFceName);
            (window as IIndexable)[window.GET_IMAGES_FCE_NAME](
                window.startSaveDesignImagesAfterImagesLoad,
                {
                    idProduct,
                    idDesign,
                    customerId,
                    guestId,
                    messages,
                }
            );
        };

        // async await not working in old OD, needs callback
        window.saveDesignAfterImagesLoad = (obj: any) => {
            dispatch(
                saveDesign(
                    obj.idProduct,
                    obj.idDesign,
                    customerId,
                    guestId,
                    window.GET_DESIGN_FCE_NAME,
                    obj.name,
                    obj.images,
                    obj.selectedData,
                    obj.teamData,
                    obj.addToCart,
                    obj.addProofService,
                    obj.saveAsNew,
                    obj.messages
                )
            );
        };
        // async await not working in old OD, needs callback
        window.startSaveDesignImagesAfterImagesLoad = (obj: any) => {
            dispatch(
                saveDesignImages(
                    obj.idDesign,
                    obj.idProduct,
                    customerId,
                    guestId,
                    obj.images,
                    obj.messages
                )
            );
        };

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const resetParameters = () => {
        setIdProduct(0);
        setIdDesign(0);
        setIsOpen(false);
        setRequireName(false);
        setOnSuccessFceName(null);
        setOnSuccessParams(null);
        setAddToCart(false);
        setAddProofService(false);
        setSaveAsNew(false);
    };

    const handleSave = (name: string, saveAsNew: boolean) => {
        if (onlyDesign) {
            dispatch(
                saveDesign(
                    idProduct,
                    idDesign,
                    customerId,
                    guestId,
                    window.GET_DESIGN_FCE_NAME,
                    name,
                    null,
                    selectedData,
                    teamData,
                    addToCart,
                    addProofService,
                    saveAsNew,
                    messages
                )
            );
        } else {
            (window as IIndexable)[window.GET_IMAGES_FCE_NAME](
                window.saveDesignAfterImagesLoad,
                {
                    idProduct,
                    idDesign,
                    name,
                    addToCart,
                    addProofService,
                    saveAsNew,
                    selectedData,
                    teamData,
                    messages,
                }
            );
        }
    };

    if (requireName) {
        return (
            <SaveDesignDialog
                isOpen={isOpen}
                getDesignNameFceName={window.GET_DESIGN_NAME_FCE_NAME}
                onClose={() => {
                    setIsOpen(false);
                }}
                onSave={handleSave}
                propSaveAsNew={saveAsNew}
            />
        );
    } else {
        return <Loading isOpen={isOpen} />;
    }
};

export default SaveContainer;
